import Top_bar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import FactoryCard from "../../Components/factoryCard/FactoryCard";
import DepartmentCard from "../../Components/departmentCard/departmentCard.js";
import DatePicker from "../../Components/datePickerDashboard/datePickerDashboard.js"
import "./dashboard.css";
import "./dashboardGeneral.css"
import { Button, Col } from "react-bootstrap";
import {faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Row } from "react-bootstrap";
import Select from '../../Components/select/select';
import { useEffect, useState } from "react";
import moment from "moment";
import api from "../../services/api.js";
import MachineCard from "../../Components/machineCard/machineCard.js";

const DashboardGeneral = ()=>{

    const [date_ini, setDateIni] = useState(moment().format("DD/MM/YYYY"));
    const [date_end, setDateEnd] = useState(moment().format("DD/MM/YYYY"));
    const [workShifts, setWorkShifts] = useState([]);
    const [workShift, setWorkShift] = useState(null);
    const [factorys, setFactorys] = useState([]);
    const [factorysInfos, setFactorysInfos] = useState([]);
    const [factory, setFactory] = useState(null);
    const [factorysCards, setFactorysCards] = useState([]);
    const [department, setDepartment] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [departmentsInfos, setDepartmentsInfos] = useState([]);
    const [departmentsCards, setDepartmentsCards] = useState([]);
    const [machines, setMachines] = useState([]);
    const [machinesInfos, setMachinesInfos] = useState([]);
    const [machinesCards, setMachinesCards] = useState([]);

    const [activeControl, setActiveControl] = useState("factory");

    const getDepartments = async ()=>{
        await api.get("/departments").then((resp)=>{
            setDepartments(resp.data);
        }).catch((error)=>{
            console.log(error);
        })
    }

    const getWorkshifts = async ()=>{
        await api.get("/work-shifts/").then((resp)=>{

            let newArr = [];

            if(resp.data.length > 0){

                newArr = [{value: null, label: "Todos"},...resp.data.map((element)=>{return {value: element.id, label: element.code}})];

            }
            
            setWorkShifts(newArr);

        }).catch((error)=>{
            console.log(error);
        })
    }

    const getMachines = async ()=>{
        await api.get("/machines").then((resp)=>{
            setMachines(resp.data);
        }).catch((error)=>{
            console.log(error);
        })
    }

    const getFactorys = async ()=>{
        await api.get("/factorys").then((resp)=>{
            setFactorys(resp.data);
        }).catch((err)=>{
            console.log(err);
        })
    }

    const filter = ()=>{

        setDepartmentsCards([]);
        setMachinesCards([]);

        let query = `ini_date=${moment(date_ini, "DD/MM/YYYY").format("YYYY-MM-DD")}&end_date=${moment(date_end, "DD/MM/YYYY").format("YYYY-MM-DD")}&`;

        if(workShift != null){
            query += `work_shift=${workShift}&`;
        }

        let facInfo = [];

        factorys.forEach(async (element, index)=>{
            await api.get(`/reports/oee-factory?${query}&factory=${element.code}`).then(async (resp)=>{
                facInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: resp.data.oeeMedium, disponibilityMedium: resp.data.disponibilityMedium, performanceMedium: resp.data.performanceMedium, qualityMedium: resp.data.qualityMedium});
                if(index == factorys.length-1){
                    setFactorysInfos(facInfo);
                }

            }).catch((error)=>{
                console.log(error);

                facInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: 0, disponibilityMedium: 0, performanceMedium: 0, qualityMedium: 0});

                if(index == factorys.length-1){
                    setFactorysInfos(facInfo);
                }

            })
        })

        if(factory != null){
            filterDepartment();
        }

        if(department != null){
            filterMachine()
        }

    }

    const filterDepartment = async ()=>{

        let query = `ini_date=${moment(date_ini, "DD/MM/YYYY").format("YYYY-MM-DD")}&end_date=${moment(date_end, "DD/MM/YYYY").format("YYYY-MM-DD")}&`;

        if(workShift != null){
            query += `work_shift=${workShift}&`;
        }

        const deps = departments.filter((element)=>element.id_factory == factory);

        let departmentInfo = [];

        deps.forEach(async (element, index)=>{

            await api.get(`/reports/oee-factory?${query}&department=${element.code}`).then(async (resp)=>{
                departmentInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: resp.data.oeeMedium, disponibilityMedium: resp.data.disponibilityMedium, performanceMedium: resp.data.performanceMedium, qualityMedium: resp.data.qualityMedium});

                if(index == deps.length-1){
                    setDepartmentsInfos(departmentInfo);
                }
    
            }).catch((error)=>{
                console.log(error);
                departmentInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: 0, disponibilityMedium: 0, performanceMedium: 0, qualityMedium: 0})
                if(index == deps.length-1){
                    setDepartmentsInfos(departmentInfo);
                }
            })

        })        
        
    }

    const filterMachine = async ()=>{
        let query = `ini_date=${moment(date_ini, "DD/MM/YYYY").format("YYYY-MM-DD")}&end_date=${moment(date_end, "DD/MM/YYYY").format("YYYY-MM-DD")}&`;

        if(workShift != null){
            query += `work_shift=${workShift}&`;
        }

        const macs = machines.filter((element)=>element.id_department == department);

        let machineInfo = [];
        macs.forEach(async (element, index)=>{
            await api.get(`/reports/oee-factory?${query}&machine_code=${element.code}&machine_desc=${element.description}`).then(async (resp)=>{
                machineInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: resp.data.oeeMedium, disponibilityMedium: resp.data.disponibilityMedium, performanceMedium: resp.data.performanceMedium, qualityMedium: resp.data.qualityMedium});
                if(index == macs.length-1){
                    setMachinesInfos(machineInfo);
                }
    
            }).catch((error)=>{
                machineInfo.push({id: element.id, code: element.code, description: element.description, oeeMedium: 0, disponibilityMedium: 0, performanceMedium: 0, qualityMedium: 0})
                if(index == macs.length-1){
                    setMachinesInfos(machineInfo);
                }
            })
        })
    }

    const constructCards = async ()=>{

        let fac = [];

        if(factorysInfos.length > 0){

            fac = factorysInfos.map((element)=>{
                let numberDepartments = departments.filter((depart)=>depart.id_factory == element.id).length;
                let numberMachines = machines.filter((machine)=>machine.factory.factory_id == element.id).length;

                return <FactoryCard description={element.description} oneCard={factorysInfos.length == 1} numberDepartments={numberDepartments} numberMachines={numberMachines} oeeMedium={element.oeeMedium} disponibilityMedium={element.disponibilityMedium} qualityMedium={element.qualityMedium} performanceMedium={element.performanceMedium} openDepartments={()=>{
                    setFactory(element.id);
                }}></FactoryCard>
            })

        }else{

            fac = factorys.map((element)=>{

                let numberDepartments = departments.filter((depart)=>depart.id_factory == element.id).length;
                let numberMachines = machines.filter((machine)=>machine.factory.factory_id == element.id).length;
                return <FactoryCard description={element.description} oneCard={factorys.length == 1} numberDepartments={numberDepartments} numberMachines={numberMachines} oeeMedium={0} disponibilityMedium={0} qualityMedium={0} performanceMedium={0} openDepartments={()=>{
                    setFactory(element.id);
                }}></FactoryCard>
            })


        }
        
        setFactorysCards(fac);

    }

    const constructDepartmentCards = ()=>{
        let dep = departmentsInfos.map((element)=>{
            let numberMachines = machines.filter((machine)=>machine.id_department == element.id).length;
            return <DepartmentCard description={element.description} oneCard={departmentsInfos.length == 1} numberMachines={numberMachines} oeeMedium={element.oeeMedium} disponibilityMedium={element.disponibilityMedium} qualityMedium={element.qualityMedium} performanceMedium={element.performanceMedium} openMachines={()=>{
                setDepartment(element.id);
            }}></DepartmentCard>
        })
        
        setDepartmentsCards(dep);
    }

    const constructMachineCards = ()=>{
        
        let mac = machinesInfos.map((element)=>{
            return <MachineCard description={`${element.description}${element.code}`} oeeMedium={element.oeeMedium} disponibilityMedium={element.disponibilityMedium} qualityMedium={element.qualityMedium} performanceMedium={element.performanceMedium}></MachineCard>
        })
        
        setMachinesCards(mac);
    }

    const openCaptions = (status) => {
        let caption = document.getElementById("caption");
        switch(status){
          case "open":
            caption.style.display = "initial";
          break;
          case "close":
            caption.style.display = "none";
          break;
          default:
            caption.style.display = "none";
        }
        
    };

    useEffect(()=>{
        constructCards();
    }, [factorysInfos, factorys, machines]);

    useEffect(()=>{
        constructDepartmentCards();
    },[departmentsInfos]);

    useEffect(()=>{
        constructMachineCards();
    },[machinesInfos]);

    useEffect(()=>{
        if(factory != null){
            filterDepartment();
        }
    },[factory]);

    useEffect(()=>{
        if(department != null){
            filterMachine();
        }
    }, [department])

    useEffect(()=>{
        filter();
    }, [factorys])
    
    useEffect(()=>{
        getDepartments();
        getMachines();
        getWorkshifts();
        getFactorys();
    }, [])

    return (<>

        <header>
            <Top_bar></Top_bar>
        </header>
        
        <main className="dg-main">
            <div style={{backgroundColor: "#f5f5f5"}}>
                <div className="dg-top-line">
                    <div className="titleMachine dg-titleMachine">
                        Dashboard Geral
                        <FontAwesomeIcon size={"1x"} icon={faInfoCircle} onMouseEnter={() => openCaptions("open")} onMouseLeave={() => openCaptions("close")}/>
                    </div>
                    <div className="lineDrops dg-lineDrops">
                        <div className="dg-select">
                            <Select label={"Turno"} arrData={workShifts} className={"dg-input-select"} handleSelect={(element)=>{
                                setWorkShift(element);
                            }}></Select>
                        </div>
                        <DatePicker title="Data inicial" className="dg-datePicker" parentCallback={(value)=>{setDateIni(value)}}></DatePicker>
                        <DatePicker title="Data final" className="dg-datePicker" parentCallback={(value)=>{setDateEnd(value)}}></DatePicker>
                        <Button onClick={filter}>Filtrar</Button>
                    </div>
                </div>
                <div className="caption" id="caption" style={{paddingLeft: "1vh"}}>Os valores apresentados nesse dashboard são calculados através de uma média simples, levando em consideração os dados presentes no relatório "OEE x Turno".</div>
                <ol className="breadcrumb dg-breadcrumb" style={{padding: "0px 0px 0px 1vh", backgroundColor: "#f5f5f5", gap: "10px"}}>
                    <li className={factory == null && department == null ? ("text-primary") : ("dg-pointer")}><a onClick={()=>{

                        setFactory(null);
                        setDepartment(null);
                        setActiveControl("factory");
                    }}>Fábricas</a></li>/
                    <li className={factory != null && department == null ? ("text-primary") : ((department == null ? "" : "dg-pointer"))}><a onClick={()=>{
                        if(factory != null){
                            setDepartment(null)
                            setActiveControl("department");
                        }
                    }}>Setores</a></li>/
                    <li className={department !== null ? ("text-primary") : ("disabled")}><a>Máquinas</a></li>/
                </ol>
            </div>

            <div className="border menu-container">
            
                <div className="machine-tracking-container dg-machine-tracking-container" style={{alignItems:'center', justifyContent:'center'}}>
                {factory == null ? (<>
                    {(factorysCards.length > 0) ? (<>
                        {factorysCards}
                    </>) : (<h1>Nenhuma fábrica encontrada.</h1>)}
                </>) : (department == null ? (<>{(departmentsCards.length > 0) ? (departmentsCards) : (<h1>Nenhum setor cadastrado.</h1>)}</>) : ((machinesCards.length > 0) ? (machinesCards) : (<h1>Nenhuma máquina cadastrada.</h1>)))}
                </div>
            </div>
        </main>
    
        {/*<BottomBar></BottomBar>*/}
    </>)

}

export default DashboardGeneral;